const GET_WATERDATA = 'GET_WATERDATA'
const SET_BASICMSG = 'SET_BASICMSG'

const SET_CAROWNERMSG = 'SET_CAROWNERMSG'
const SET_HOLDERMSG = 'SET_HOLDERMSG'
const SET_INSUREDMSG = 'SET_INSUREDMSG'
const SET_CARMSG = 'SET_CARMSG'
const SET_DISTRIBUTEMSG = 'SET_DISTRIBUTEMSG'
const SET_SYSTEMORDERNUMBER = 'SET_SYSTEMORDERNUMBER'

export default {
	[GET_WATERDATA](state, payload) {
		if (payload.res.code == 200){
				state.wateritem = payload.res.msg.records;
				if (payload.res.msg.records.length < state.pageSize){
					state.indexEnd = true;
			}
		 }
	},

  [SET_BASICMSG](state,payload){
		state.basicMsg = payload;
	},
	[SET_CAROWNERMSG](state,payload){
		state.carOwnerMsg = payload;
	},
	[SET_HOLDERMSG](state,payload){
		state.holderMsg = payload;
	},
	[SET_INSUREDMSG](state,payload){
		state.insuredMsg = payload;
	},
	[SET_CARMSG](state,payload){
		state.carMsg = payload;
	},
	[SET_DISTRIBUTEMSG](state,payload){
		state.distributeMsg = payload;
	},
	[SET_SYSTEMORDERNUMBER](state,payload){
		state.systemorderNumber = payload;
	},





}



// WEBPACK FOOTER //
// ./src/store/mutations.js